import { SimpleGrid } from "@chakra-ui/react";
import CardDefault from "ui/components/Cards/CardDefault";
import { Heading } from "@chakra-ui/react";
import ResumoItem from "./ResumoItem";
import { CgCheckO } from "react-icons/cg";
import {
  MdOutlineContentCopy,
  MdSearchOff,
  MdOutlineSubtitles,
} from "react-icons/md";
import { useRetornoBancarioResumo } from "core/features/retorno-bancario/hooks/useRetornoBancarioResumo";

function ResumoContainer({
  title,
  color,
  dataFim,
  dataInicio,
}: {
  title: string;
  color: string;
  dataFim: string;
  dataInicio: string;
}) {
  const { data, isFetching } = useRetornoBancarioResumo({
    dataFim,
    dataInicio,
  });

  return (
    <CardDefault pt="12px">
      <Heading
        as="h3"
        my="8px"
        lineHeight="1"
        size="lg"
        textAlign="center"
        color={color}
      >
        {title}
      </Heading>

      <SimpleGrid columns={{ sm: 2, md: 2, lg: 4 }} gap="16px" marginTop="14px">
        <ResumoItem
          icon={<CgCheckO fontSize="15px" />}
          description="Itens em conforme"
          value={data?.conformes ?? 0}
          color={color}
          isLoading={isFetching}
        />
        <ResumoItem
          icon={<MdOutlineContentCopy fontSize="15px" />}
          description="Itens duplicados"
          value={data?.duplicados ?? 0}
          color={color}
          isLoading={isFetching}
        />
        <ResumoItem
          icon={<MdSearchOff fontSize="15px" />}
          description="Itens não localizados ou não conforme"
          value={data?.incorretos ?? 0}
          color={color}
          isLoading={isFetching}
        />
        <ResumoItem
          icon={<MdOutlineSubtitles fontSize="15px" />}
          description="Itens com diferença"
          value={data?.diferencas ?? 0}
          color={color}
          isLoading={isFetching}
        />
      </SimpleGrid>
    </CardDefault>
  );
}

export default ResumoContainer;
